import { getMapNodeShadowCssVariables } from "../utils/mapThemes.js";

const THEME_TOKEN_VARIABLES = {
  background: "--map-background",
  grid: "--map-grid",
  node: "--map-node",
  nodeBorder: "--map-node-border",
  text: "--map-text",
  focalNode: "--map-focal-node",
  focalBorder: "--map-focal-border",
  coreNode: "--map-core-node",
  coreBorder: "--map-core-border",
  detailNode: "--map-detail-node",
  detailBorder: "--map-detail-border",
  labelHalo: "--map-label-halo",
};

export function getEmbedThemeCssVariables(themeTokens) {
  if (!themeTokens || typeof themeTokens !== "object" || Array.isArray(themeTokens)) return {};
  const variables = Object.fromEntries(Object.entries(THEME_TOKEN_VARIABLES).flatMap(([token, variable]) => {
    const value = themeTokens[token];
    return typeof value === "string" && value.trim() ? [[variable, value.trim()]] : [];
  }));
  const node = themeTokens.nodeStyle || {};
  const type = themeTokens.typography || {};
  const label = themeTokens.relationshipLabelStyle || {};
  const numeric = (value) => Number.isFinite(Number(value)) ? Number(value) : null;
  const optional = [
    ["--map-node-radius-focal", numeric(node.focalRadius), "px"],
    ["--map-node-radius-core", numeric(node.coreRadius), "px"],
    ["--map-node-radius-supporting", numeric(node.supportingRadius), "px"],
    ["--map-node-radius-detail", numeric(node.detailRadius), "px"],
    ["--map-node-border-scale", numeric(node.borderWidthScale), ""],
    ["--map-node-weight-focal", numeric(type.focalWeight), ""],
    ["--map-node-weight-core", numeric(type.coreWeight), ""],
    ["--map-node-weight-supporting", numeric(type.supportingWeight), ""],
    ["--map-node-weight-detail", numeric(type.detailWeight), ""],
    ["--map-edge-label-size", numeric(label.fontSize), "px"],
    ["--map-edge-label-weight", numeric(label.fontWeight), ""],
    ["--map-edge-label-halo-width", numeric(label.haloPadding) == null ? null : numeric(label.haloPadding) * 2, "px"],
    ["--map-edge-label-halo-opacity", numeric(label.haloOpacity), ""],
  ];
  for (const [name, value, unit] of optional) if (value != null) variables[name] = `${value}${unit}`;
  Object.assign(variables, getMapNodeShadowCssVariables(node.shadow));
  return variables;
}
